import React from "react";
import { Route } from "react-router-dom";
export const getRoutes = (allRoutes) =>
  allRoutes.map((route) => {
    if (route.collapse) {
      return getRoutes(route.collapse);
    }

    if (route.route) {
      return <Route exact path={route.route} element={route.component} key={route.key} />;
    }

    return null;
  });

export const showSidebar = !["/login"].some((pattern) => {
  if (typeof pattern === "string") {
    // eslint-disable-next-line no-restricted-globals
    return location.pathname === pattern;
  } else if (pattern instanceof RegExp) {
    // eslint-disable-next-line no-restricted-globals
    return pattern.test(location.pathname);
  }
});
